/** Ephemeral read identity for the state detail pane. Nothing is persisted or logged. */
export function geoDetailKey({role,token,state,category,filter,search,page}) {
 return JSON.stringify([role||'',token||'',state||'',category||'',filter||'',search||'',Number(page)||1]);
}
export function selectGeoDetail(detail,recordedKey,currentKey) {
 return recordedKey===currentKey?detail:null;
}
